import React from 'react';
import { Input, Space, Divider } from 'antd';
import VideoUploader from './VideoUploader';
import VideoSelector from './VideoSelector';
import styles from '../../../event-timeline.module.css';

const LABELS = {
  VIDEO_URL: 'Cutscene Video URL:',
  SELECT_FROM_INVENTORY: 'Select from My Inventory:',
  UPLOAD_NEW: 'Upload New Video:',
} as const;

const PLACEHOLDERS = {
  VIDEO_URL: 'Enter Cutscene Video URL',
} as const;

interface PlayCutsceneParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const createSafeParams = (params: any) => params || {};

const PlayCutsceneParams: React.FC<PlayCutsceneParamsProps> = ({
  params,
  setParams,
}) => {
  const safeParams = createSafeParams(params);

  const handleVideoUploaded = (videoUrl: string): void => {
    setParams({ ...safeParams, videoUrl });
  };

  const handleVideoSelected = (videoUrl: string): void => {
    setParams({ ...safeParams, videoUrl });
  };

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setParams({ ...safeParams, videoUrl: e.target.value });
  };

  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span className={styles.label}>{LABELS.VIDEO_URL}</span>
        <Input
          value={safeParams.videoUrl || ''}
          onChange={handleUrlChange}
          placeholder={PLACEHOLDERS.VIDEO_URL}
        />

        <Divider className={styles.divider} />

        <div>
          <span className={styles.label}>{LABELS.SELECT_FROM_INVENTORY}</span>
          <VideoSelector
            onVideoSelected={handleVideoSelected}
            currentVideoUrl={safeParams.videoUrl}
          />
        </div>

        <Divider className={styles.divider} />

        <div>
          <span className={styles.label}>{LABELS.UPLOAD_NEW}</span>
          <VideoUploader onVideoUploaded={handleVideoUploaded} />
        </div>
      </Space>
    </div>
  );
};

export default PlayCutsceneParams;
